import { Typography, styled } from '@ori-ui/mui';
import { shouldNotForwardProp } from '@ori/presentation-utils';

import { getCurrentPriceColor } from './utils';

export const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
});

interface CurrentPriceProps {
  oldPriceVisible?: boolean;
}
export const CurrentPrice = styled(Typography, {
  shouldForwardProp: shouldNotForwardProp(['oldPriceVisible']),
})<CurrentPriceProps>(({ oldPriceVisible, theme }) => ({
  color: getCurrentPriceColor(theme, oldPriceVisible),
}));

export const OldPrice = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey.A700,
}));
